export const GLOBAL_LOADING = "GLOBAL_LOADING";
export const GLOBAL_SUCCESSFUL = "GLOBAL_SUCCESSFUL";
export const GLOBAL_ERROR = "GLOBAL_ERROR";
export const GLOBAL_WARNING = "GLOBAL_WARNING";
export const GLOBAL_TIMEOUT = "GLOBAL_TIMEOUT";
export const GLOBAL_SUCCESSFUL_SAVED = "GLOBAL_SUCCESSFUL_SAVED";
